export type StoredEmailFlagData = {
  source?: string | null;
  pinned?: boolean | null;
  flagStatus?: string | null;
  graph?: { flagStatus?: string | null } | null;
};

/**
 * Resolve the displayed follow-up flag state from a stored email document.
 * Graph's status wins over the legacy `pinned` field so records written while
 * the old sync guard was active repair themselves as soon as they are read.
 */
export function getEmailFlaggedState(data: StoredEmailFlagData | null | undefined): boolean {
  if (!data) return false;

  if (data.source === 'graph') {
    const status = data.graph?.flagStatus || data.flagStatus;
    if (status === 'flagged') return true;
    if (status === 'notFlagged' || status === 'complete') return false;
  }

  return data.pinned === true;
}

/** Fields for an optimistic Graph flag write and its rollback. */
export function getGraphFlagWrite(flagged: boolean): Record<string, boolean | string> {
  const flagStatus = flagged ? 'flagged' : 'notFlagged';
  return {
    pinned: flagged,
    flagStatus,
    'graph.flagStatus': flagStatus,
  };
}
